import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 border-b border-black-200 pb-24" }
const _hoisted_2 = { class: "mt-12 flex justify-between gap-x-8 laptop:gap-x-16" }
const _hoisted_3 = { class: "mt-12 flex items-center gap-x-12 uppercase" }
const _hoisted_4 = { class: "text-black-900" }
const _hoisted_5 = { class: "mt-24 grid auto-rows-max grid-cols-3 gap-x-8" }
const _hoisted_6 = { class: "mt-24 grid auto-rows-max grid-cols-3 gap-x-8" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton = _resolveComponent("v-skeleton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_skeleton, {
        rep: 3,
        class: "h-52 w-full tablet:h-64"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_skeleton, { class: "h-28 w-80" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_skeleton, {
          rep: 3,
          class: "aspect-kit h-full w-full"
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_skeleton, {
          rep: 2,
          class: "aspect-kit h-full w-full"
        })
      ])
    ])
  ]))
}